/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_FilewordiconInputs */

const en_enum_custom_page_icon_filewordicon = /** @type {(inputs: Enum_Custom_Page_Icon_FilewordiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Word`)
};

const de_enum_custom_page_icon_filewordicon = /** @type {(inputs: Enum_Custom_Page_Icon_FilewordiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word-Datei`)
};

/**
* | output |
* | --- |
* | "File Word" |
*
* @param {Enum_Custom_Page_Icon_FilewordiconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_filewordicon = /** @type {((inputs?: Enum_Custom_Page_Icon_FilewordiconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_FilewordiconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_filewordicon(inputs)
	return de_enum_custom_page_icon_filewordicon(inputs)
});